import { Box } from '@mui/material';
import React from 'react';
import CommonNavbar from './CommonNavbar';
import WhatsappFAB from './WhatsappFAB';



const CommonHeader: React.FC = () => {
    return (
        <Box>
            <CommonNavbar />
            {/* <CartFAB /> */}
            <WhatsappFAB
                phoneNumber="972542421677"
                message="שלום, אני מעוניין לקבל מידע נוסף"
            />
        </Box>
    );
};

export default CommonHeader;
